import { createContext, Dispatch, SetStateAction } from 'react';
import { Socket } from 'socket.io-client';
import { SocketSubscriptionMap } from './models';

export interface WebsocketData {
    connected: boolean;
    authenticated: boolean;
    socket: Socket;
    setSubscriptions: Dispatch<SetStateAction<SocketSubscriptionMap>>;
}

/**
 * React context
 */
export const WebsocketContext = createContext<WebsocketData | undefined>(
    undefined
);
